// Navigation
import Glide from '@glidejs/glide';

$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }
});

$(window).on('load', function () {
    $('.home-page-title-container').each(watchHomePageTitle)
    $(window).on('resize', watchHomePageTitle)
});

$(document).ready(function () {
    if ($('.HomePage').children('.video-container').children('video').length) {
        watchHomeVideo()
    }

    if ($('.glide.video-gallery-glide-container').length) {
        $('.glide.video-gallery-glide-container').each(function () {
            initVideoCarousel($(this));
            watchVideoCarousel($(this).parent(), $(this));
        });
    }

    if ($('.main-video-container').length) {
        watchMainVideos();
    }

    $('.home-page-title-container').each(watchHomePageTitle)
    $(window).on('resize', watchHomePageTitle)

    if ($('ul.rotating-list').length) {
        $('ul.rotating-list').each(function () {
            let $RotatingList = $(this);
            $RotatingList.wrap('<div class="marquee-container"></div>');
            let $ListItems = $RotatingList.find('li');

            $ListItems.each(function () {
                $RotatingList.append($(this).clone());
            });
        });
    }

    preloadVideos();

    // On the tablet kiosk pages are switched by JavaScript, so tablet-kiosk.js reports those itself
    if (!$('body').hasClass('tablet-kiosk')) {
        analyticsPageView(window.location.pathname, document.title);
    }
});

function trackVideoStart($videoContainer) {
    let name = $videoContainer.find('.video-title').first().text().trim();

    if (!name) {
        // Titles are optional in the CMS, so fall back to the file name. preloadVideos() swaps src for a blob:
        // URL, whose last segment is a meaningless GUID, so it keeps the real URL in data-original-src
        let $source = $videoContainer.find('source').first();
        name = ($source.attr('data-original-src') || $source.attr('src') || '').split('/').pop();
    }

    analyticsVideoView(name);
}

// <source> elements taken out of videos by resetVideo(), waiting to be put back by playVideo()
let unloadedVideoSources = new WeakMap();

// Switching away from a gallery video. Android Chrome keeps a video's decoder and buffers alive for as long as
// the <video> has a source, even when it's paused, so on a kiosk that's been through a few dozen videos they
// pile up until the browser falls over. A video with no <source> and a load() call has its player torn down, so
// the source is taken out here and put back by playVideo() when the video is next needed.
//
// It's the same blob: URL going back in, so that costs nothing and never touches the network. If the video
// isn't in memory as a blob (the normal site, or a download that hasn't finished or failed) taking the source
// out would mean fetching it again, so there it's just paused and rewound like it always was.
function resetVideo(video) {
    if (unloadedVideoSources.has(video)) {
        return;
    }

    let sources = Array.from(video.querySelectorAll('source'));
    let inMemory = sources.length > 0 && sources.every(function (source) {
        return (source.getAttribute('src') || '').indexOf('blob:') === 0;
    });

    video.pause();

    if (!inMemory) {
        setTimeout(function () {
            video.currentTime = 0;
        }, 50);
        return;
    }

    sources.forEach(function (source) {
        video.removeChild(source);
    });
    unloadedVideoSources.set(video, sources);

    // With nothing to play, this destroys the media player and puts the position back to 0
    video.load();
}

// Plays a gallery video, putting its source back first if resetVideo() took it out
function playVideo(video) {
    let sources = unloadedVideoSources.get(video);

    if (sources) {
        unloadedVideoSources.delete(video);
        sources.forEach(function (source) {
            video.appendChild(source);
        });
        video.load();
    }

    let playing = video.play();

    if (playing && playing.catch) {
        playing.catch(function (err) {
            // Switching away before it has started aborts the pending play(), which is fine
            if (err.name !== 'AbortError') {
                console.warn('Video failed to play:', err);
            }
        });
    }
}

// Downloaded videos, keyed by their original URL, as blob: URLs. A blob already in the browser's memory
// keeps playing if the kiosk loses its internet connection; a plain fetch() (the old approach) only warms
// whatever HTTP cache the browser feels like keeping, which isn't reliable enough for an offline kiosk.
let videoBlobs = {};

// Only the tablet kiosk has a #sections-container, so this is a no-op on the normal site
function preloadVideos() {
    let videoUrls = [];

    $('#sections-container video source').each(function () {
        let src = $(this).attr('src');
        if (src && !videoUrls.includes(src)) {
            videoUrls.push(src);
        }
    });

    if (!videoUrls.length) {
        return Promise.resolve();
    }

    let $loadingStatus = $('#loading-status');
    let $progressBar = $('#progress-bar');
    let loadedCount = 0;

    let downloads = videoUrls.map(function (url) {
        if (videoBlobs[url]) {
            return Promise.resolve();
        }

        $loadingStatus.text('Downloading video ' + (loadedCount + 1) + ' of ' + videoUrls.length + '...');

        return fetch(url)
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('HTTP ' + response.status);
                }
                return response.blob();
            })
            .then(function (blob) {
                videoBlobs[url] = URL.createObjectURL(blob);
            })
            .catch(function (err) {
                // Leave the <source> pointing at the network URL so playback still works while online
                console.error('Failed to preload video:', url, err);
            })
            .then(function () {
                loadedCount++;
                $progressBar.css('width', Math.round((loadedCount / videoUrls.length) * 100) + '%');
            });
    });

    return Promise.all(downloads).then(function () {
        // Swap every <source> over to its blob
        $('#sections-container video').each(function () {
            let video = this;
            let swapped = false;

            $(video).find('source').each(function () {
                let blobUrl = videoBlobs[this.getAttribute('src')];

                if (blobUrl) {
                    this.setAttribute('data-original-src', this.getAttribute('src'));
                    this.setAttribute('src', blobUrl);
                    swapped = true;
                }
            });

            if (!swapped) {
                return;
            }

            let wasPlaying = !video.paused && !video.ended;
            let resumeAt = video.currentTime;

            // Gallery videos stay unloaded until a visitor asks for one (see resetVideo/playVideo), so that the
            // browser isn't holding a decoder for every video on the kiosk. They're in memory as blobs, which is
            // all offline playback needs. One that's already playing is a visitor who got in early, so it carries on.
            if (!wasPlaying && $(video).closest('.main-video-container').length) {
                resetVideo(video);
                return;
            }

            // Reload the video element so the swap takes effect
            video.load();

            // The homepage video autoplays as soon as the page is shown, well before downloads finish,
            // so reloading it needs to pick back up where it was rather than visibly restarting
            if (wasPlaying) {
                video.currentTime = resumeAt;
                video.play().catch(function () {
                });
            }
        });

        $loadingStatus.text('All videos loaded! Ready for offline use.');
    });
}

function watchHomeVideo() {
    let $homeVideo = $('.HomePage').children('.video-container').children('video');
    let $homePageTitleContainer = $('.home-page-title-container');

    $homeVideo.on('play', function () {
        $('.home-page-title-container').addClass('playing');
    });

    $homeVideo.on('pause', function () {
        $('.home-page-title-container').removeClass('playing');
    });

    if (!$homePageTitleContainer.hasClass('playing')) {
        $homeVideo[0].play();
    }
}

function watchHomePageTitle() {
    // console.log('watchHomePageTitle')
    let $title = $('.home-page-title');
    $title.text($title.text())
    let $container = $('.home-page-title-container').addClass('resizing');
    let originalText = $title.text().trim();
    let words = originalText.split(' ');
    let lines = [];
    let currentLine = [];
    let lastTop = null;

    // Use a hidden clone for measurement instead of modifying the real element
    let $clone = $title.clone()
        .css({
            'position': 'absolute',
            'visibility': 'hidden',
            'width': $title.width() + 'px',
            'font-size': $title.css('font-size'),
            'font-family': $title.css('font-family'),
            'font-weight': $title.css('font-weight'),
            'line-height': $title.css('line-height'),
        })
        .html(words.map(w => `<span style="display:inline-block;">${w}&nbsp;</span>`).join(''))
        .appendTo('body');

    $clone.children('span').each(function () {
        let top = Math.round(this.getBoundingClientRect().top);
        let word = $(this).text().replace('\u00a0', '');

        if (lastTop !== null && top !== lastTop) {
            lines.push(currentLine.join(' '));
            currentLine = [];
        }
        currentLine.push(word);
        lastTop = top;
    });

    if (currentLine.length) lines.push(currentLine.join(' '));

    $clone.remove();

    // Now update the real element
    $title.html(lines.map(l => `<span class="title-line"><span class="title-line-inner">${l}</span></span>`).join(' '));

    $container.removeClass('resizing')

    do {
        var $last = null,
            lastw = null,
            clean = true,
            minOverlap = parseFloat($title.css('--min-overlap'))
        $title.find('.title-line').each(function () {
            var $this = $(this),
                w = $(this).find('.title-line-inner').outerWidth()
            if (lastw && lastw > w) {
                //This line is narrower than the last
                $(this).addClass('curve-top')
                if (lastw - w < minOverlap) {
                    $last.css('--line-padding', Math.ceil(parseFloat($last.css('--line-padding')) + minOverlap - lastw + w) + 'px')
                    clean = false
                }
            }
            if (lastw && lastw < w) {
                //This line is wider than the last
                $last.addClass('curve-bottom')
                if (w - lastw < minOverlap) {
                    $this.css('--line-padding', Math.ceil(parseFloat($this.css('--line-padding')) + minOverlap - lastw + w) + 'px')
                    clean = false
                }
            }
            $last = $this
            lastw = w
        })
    } while (!clean)
}

function watchMainVideos() {
    let $container = $('.main-video-container');
    let $mainVids = $container.children('.video-container');

        $mainVids.each(function () {
            let $vid = $(this);
            let $video = $vid.children('.video-item-container').children('video');

            // Prevent video's own click from interfering
            $video.on('click', function (e) {
                e.stopPropagation();
                $vid.trigger('click');
            });

            $vid.on('click', function (e) {
                e.stopPropagation();
                let videoEl = $video[0];
                let target = $(this).data('video-pos');

                if ($vid.hasClass('playing')) {
                    $vid.removeClass('playing');
                    $vid.addClass('bg-primary-gradient');
                    videoEl.pause();

                    // Use find to catch clones too
                    $('.video-gallery-glide-container').find('.video-item').each(function () {
                        if ($(this).data('video-pos') === target) {
                            $(this).removeClass('active');
                        }
                    });
                } else {
                    $vid.addClass('playing');
                    $vid.removeClass('bg-primary-gradient');

                    // Only a start (or replay) is a view, not resuming after a pause
                    let isStart = videoEl.currentTime < 0.5 || videoEl.ended;

                    playVideo(videoEl);

                    // After playVideo(), which puts the <source> back for trackVideoStart() to read
                    if (isStart) {
                        trackVideoStart($vid);
                    }

                    // Use find to catch clones too
                    $('.video-gallery-glide-container').find('.video-item').each(function () {
                        if ($(this).data('video-pos') === target) {
                            $(this).addClass('active');
                        }
                    });
                }
            });
        });
}

function watchVideoCarousel($vidGalleryContainer, $glideContainer) {
    let $mainVids = $vidGalleryContainer.children('.main-video-container').children('.video-container');

    // Use event delegation on the glide container instead of direct binding
    $glideContainer.on('click', '.video-item', function () {
        let $target = $(this).data('video-pos');

        // Update active state on all video items including clones
        $glideContainer.find('.video-item').each(function () {
            if ($(this).data('video-pos') === $target) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });

        $mainVids.each(function () {
            $(this).removeClass('active');

            let videoEl = $(this).children('.video-item-container').children('video')[0];

            // Everything is stopped and unloaded, including the one that's about to be played again, which
            // restarts it from the beginning
            resetVideo(videoEl);

            if ($(this).hasClass('playing')) {
                $(this).removeClass('playing');
                $(this).addClass('bg-primary-gradient');
            }

            if ($(this).data('video-pos') === $target) {
                $(this).addClass('active playing');
                playVideo(videoEl);
                trackVideoStart($(this));
            }
        });
    });
}

function initVideoCarousel($glide) {
    let $glideID = $glide.attr('id');
    let $glideEle = $(`#${$glideID}`)[0];
    let $mainGlide;

    $mainGlide = new Glide($glideEle, {
        type: "carousel",
        perView: 2.5,
        keyboard: true,
        swipeThreshold: 100,
        gap: 20,
        breakpoints: {
            768: {perView: 1.75},
            481: {perView: 1.5}
        }
    }).mount();

    window.setTimeout(function () {
        $mainGlide.update();
    }, 1250)
}
